import React from 'react';

import JogoVelha from'./pages/JogoVelha/index'

function App() {
  return (
    <div >
      <JogoVelha />
    </div>
  );
}

export default App;
